<template>
  <div class="page-box">
    <div class="page-content">
      <div class="content-box">
        <div class="list-box">
          <div class="banner-title-box">
            <div class="banner-title">{{ candidateObj.name }}预约</div>
            <div class="item-price">
              <span class="unit1">¥</span>
              {{ candidateObj.price === 0 ? '免费' : candidateObj.price }}
              <span class="unit2">/{{ candidateObj.unit }}</span>
            </div>
          </div>
          <div class="list-main">
            <div
              class="list-item"
              v-for="(item, index) in candidateList"
              @click="handleSelect(item)"
              :key="index"
            >
              <div
                class="item-main"
                :class="{ active: currentSeleted(item), disabled: !item.flag }"
              >
                <img
                  v-if="currentSeleted(item)"
                  class="check-icon"
                  src="/static/images/candidate-check-icon.png"
                  alt=""
                />
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="appointment-box">
      <div class="appointment-btn" @click="handleSubmit">确定</div>
    </div>
  </div>
</template>
<script>
import { candidate } from "@/api/index";
export default {
  data() {
    return {
      candidateList: [],
      selectList: [],
      candidateObj: {},
    };
  },
  mounted() {
    this.getCandidateList();
    if (sessionStorage.getItem("candidate") !== null) {
      this.candidateObj = JSON.parse(sessionStorage.getItem("candidate"));
    }
  },
  methods: {
    handleSubmit() {
      if (sessionStorage.getItem("candidate") !== null) {
        if (this.selectList.length > 0) {
          sessionStorage.setItem(
            "candidate",
            JSON.stringify(
              Object.assign(
                this.candidateObj,
                this.candidateObj.selectTimeData.push({
                  candidateValue: this.selectList[0].value,
                  serviceName: this.candidateObj.name, // 服务名称
                  price: this.candidateObj.price, // 服务价格
                  primaryKey: this.candidateObj.spuId, // 服务key
                })
              )
            )
          );
          this.$router.push({
            path: "/candidateInfo",
            query: {
              candidateValue: this.selectList[0].value,
            },
          });
        } else {
          this.$Toast("请选择候补");
        }
      }else {
        this.$toast('请重新服务项')
      }
    },
    currentSeleted(itemData) {
      const result = this.selectList.findIndex((item) => {
        return item.name === itemData.name;
      });
      return itemData.flag && result > -1 ? true : false;
    },
    handleSelect(selectItem) {
      if (selectItem.flag) {
        const res = this.selectList.findIndex((item) => {
          return item.name === selectItem.name;
        });
        if (res > -1) {
          this.selectList.splice(res, 1);
        } else {
          this.selectList = [];
          this.selectList.push(selectItem);
        }
      } else {
        this.$Toast("当前候补已满");
      }
    },
    async getCandidateList() {
      // if (sessionStorage.getItem("candidate") !== null) {
      //   this.candidateObj = JSON.parse(sessionStorage.getItem("candidate"));
      const result = await candidate({
        shopId: this.$route.query.shopId,
        spuId: this.$route.query.spuId,
        presentDate: this.$route.query.presentDate,
      });
      if (result.success) {
        this.candidateList = result.data.rows;
      }
      // }
    },
  },
};
</script>
<style lang="scss" scoped>
.page-box {
  background: #eeeeee;
  padding: 0 12px 10px;
}
.content-box {
  flex: 1;
  overflow: auto;
}
.list-box {
  margin-top: 10px;
  border-radius: 5px;
  background: #fff;
  .banner-title-box {
    padding: 15px 10px;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .banner-title {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #333333;
      margin-right: 10px;
    }
    .item-price {
      display: flex;
      align-items: center;
      color: #16aa77;
      font-size: 16px;
      font-family: PingFangSC-Regular;
      font-weight: 600;
      .unit1 {
        font-size: 12px;
        font-family: PingFangSC-Semibold;
      }
      .unit2 {
        font-size: 12px;
        font-family: PingFangSC-Regular;
        font-weight: normal;
        color: #666666;
      }
    }
  }

  .list-main {
    padding: 0 5px 10px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;

    .list-item {
      width: 25%;
      height: 40px;
      padding: 0 5px;
      margin-bottom: 5px;

      .item-main {
        border-radius: 3px;
        border: 1px solid #eaeaea;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        position: relative;
        color: #333;
        background: #fff;
        height: 100%;
      }
      .waiting-main {
        border-radius: 3px;
        border: 1px solid #eaeaea;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: row;
        position: relative;
        color: #ff9900;
        background: #fff;
        height: 100%;
        & > span:last-child {
          margin-left: 2px;
        }
      }

      .disabled {
        background: #f4f4f4;
        color: #666;
      }

      .active {
        border: 1px solid #ff9900;
        color: #ff9900;
        background: #fff;

        .check-icon {
          position: absolute;
          right: -1px;
          top: -1px;
          width: 17px;
          height: 17px;
        }
      }
    }
    .service-item {
      width: 20%;
      height: 43px;
      padding: 0 5px;
      margin-bottom: 5px;
      .service-main {
        border-radius: 3px;
        border: 1px solid #eaeaea;
        display: flex;
        font-weight: 500;
        align-items: center;
        justify-content: center;
        position: relative;
        color: #333;
        background: #fff;
        height: 100%;
      }

      .disabled {
        background: #f4f4f4;
        color: #666;
      }

      .active {
        border: 1px solid #16aa77;
        color: #16aa78;
        background: #fff;

        .check-icon {
          position: absolute;
          right: -1px;
          top: 0;
          width: 17px;
          height: 17px;
        }
      }
    }
  }
}
.appointment-box {
  padding: 15px 10px;
  .appointment-text {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #16aa77;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .appointment-btn {
    background: #16aa77;
    border-radius: 20px;
    height: 40px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 15px;
  }
}
</style>
